export default __webpack_public_path__ + "static/media/image@3x.53a45026.png";